import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../../config';
import './LandingPage.css';
import HeroHeader from './HeroHeader';
import LandingBodyContainer from './LandingBodyContainer';
import PartnershipSection from './PartnershipSection';

const LandingPage = () => {
    return (
        <div className="containerDiv">
            <HeroHeader />
            <LandingBodyContainer />
            <PartnershipSection />
        </div>
    );
};

export default LandingPage;